import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { TranslocoService } from "@ngneat/transloco";

@Injectable({
  providedIn: 'root'
})
export class LoggedUser {

  private readonly DEFAULT_LANGUAGE = 'es';

  userObservable: ReplaySubject<User>;

  constructor(private router: Router,
              private translocoService: TranslocoService,
              private http: HttpClient) {
    this.userObservable = new ReplaySubject<User>();
    this.reloadUser();
  }

  public reloadUser(): void {
    this.http.get<any>('/rest/me').toPromise().then(user => {
        this.userObservable.next(user);
      }
    ).catch( (err) => this.userObservable.next( new User() ));
    this.http.get<any>('/rest/me/additionalData').toPromise().then(additionalUserData => {
      this.translocoService.setActiveLang(additionalUserData.language ?? this.DEFAULT_LANGUAGE);
    });
  }
}

export class User {
  name: string;
  attributes: {
    username: string;
    tenant: string;
    organization: string;
  };
  authorities: Authority[];
}

export class Authority {
  authority: string;
}

